import type { ReactNode } from 'react';
import { Navigate, useRouteLoaderData } from 'react-router-dom';
import type { RootLoaderData } from '../App';

type Role = 'owner' | 'admin' | 'manager' | 'employee';

interface PermissionRouteProps {
  children: ReactNode;
  /** User must have one of these roles to access the route. Redirects to /home otherwise. */
  roles: Role[];
}

export function PermissionRoute({ children, roles }: PermissionRouteProps) {
  const data = useRouteLoaderData('root') as RootLoaderData | undefined;
  const roleName = data?.membership?.role_name as Role | null | undefined;

  if (!roleName || !roles.includes(roleName)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
